
export default function PartnersGrid() {
  const partners = [
    {
      name: 'Hikvision',
      category: 'Vidéo Surveillance',
      description: 'Leader mondial des solutions de vidéo surveillance IP et analogique haute définition.',
      logo: 'https://public.readdy.ai/ai/img_res/f531585a2646d3d38e47abdc603f508b.jpg',
      products: ['Caméras IP', 'NVR', 'Systèmes d\'analyse'],
      partnership: 'Partenaire Gold'
    },
    {
      name: 'Dahua',
      category: 'Sécurité Électronique',
      description: 'Solutions complètes de sécurité électronique et de surveillance intelligente.',
      logo: 'https://readdy.ai/api/search-image?query=Dahua%20Technology%20company%20logo%20on%20clean%20white%20background%2C%20professional%20security%20brand%20logo%2C%20modern%20corporate%20branding%2C%20surveillance%20technology%20logo&width=200&height=100&seq=dahua-logo&orientation=landscape',
      products: ['Caméras thermiques', 'Contrôle d\'accès', 'Alarmes'],
      partnership: 'Partenaire Platinum'
    },
    {
      name: 'Kilsen',
      category: 'Détection Incendie',
      description: 'Spécialiste européen des systèmes de détection incendie et de sécurité des bâtiments.',
      logo: 'https://readdy.ai/api/search-image?query=Kilsen%20company%20logo%20on%20clean%20white%20background%2C%20professional%20fire%20detection%20brand%20logo%2C%20European%20security%20technology%20company%20branding&width=200&height=100&seq=kilsen-logo&orientation=landscape',
      products: ['Détecteurs de fumée', 'Centrales incendie', 'Systèmes d\'évacuation'],
      partnership: 'Partenaire Certifié'
    },
    {
      name: 'Aritech',
      category: 'Anti-Intrusion',
      description: 'Solutions professionnelles d\'alarme anti-intrusion et de sécurité périmétrique avancée.',
      logo: 'https://readdy.ai/api/search-image?query=Aritech%20security%20systems%20logo%20on%20clean%20white%20background%2C%20professional%20alarm%20brand%20logo%2C%20intrusion%20detection%20company%20branding&width=200&height=100&seq=aritech-logo&orientation=landscape',
      products: ['Centrales d\'alarme', 'Détecteurs PIR', 'Sirènes'],
      partnership: 'Partenaire Gold'
    },
    {
      name: 'General Electric',
      category: 'Systèmes Intégrés',
      description: 'Solutions industrielles de sécurité et systèmes de gestion technique du bâtiment.',
      logo: 'https://readdy.ai/api/search-image?query=General%20Electric%20GE%20logo%20on%20clean%20white%20background%2C%20professional%20industrial%20brand%20logo%2C%20American%20technology%20company%20branding&width=200&height=100&seq=ge-logo&orientation=landscape',
      products: ['Systèmes GTB', 'Contrôle industriel', 'Automation'],
      partnership: 'Partenaire Agréé'
    },
    {
      name: 'ZKTeco',
      category: 'Biométrie & Accès',
      description: 'Solutions biométriques et de contrôle d\'accès basées sur les dernières technologies.',
      logo: 'https://readdy.ai/api/search-image?query=ZKTeco%20company%20logo%20on%20clean%20white%20background%2C%20professional%20biometric%20technology%20brand%20logo%2C%20access%20control%20company%20branding&width=200&height=100&seq=zkteco-logo&orientation=landscape',
      products: ['Lecteurs biométriques', 'Terminaux', 'Logiciels'],
      partnership: 'Partenaire Silver'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nos Partenaires <span className="text-red-600">Technologiques</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des collaborations privilégiées avec les leaders mondiaux pour vous garantir 
            les meilleures solutions de sécurité
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {partners.map((partner) => (
            <div key={partner.name} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <div className="p-6 border-b border-gray-100">
                <div className="flex items-center justify-between mb-4">
                  <img
                    src={partner.logo}
                    alt={`${partner.name} logo`}
                    className="h-12 object-contain"
                  />
                  <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                    partner.partnership === 'Partenaire Platinum' ? 'bg-purple-100 text-purple-800' :
                    partner.partnership === 'Partenaire Gold' ? 'bg-yellow-100 text-yellow-800' :
                    partner.partnership === 'Partenaire Silver' ? 'bg-gray-100 text-gray-800' :
                    'bg-blue-100 text-blue-800'
                  }`}>
                    {partner.partnership}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{partner.name}</h3>
                <div className="text-red-600 font-medium text-sm mb-3">{partner.category}</div>
              </div>
              
              <div className="p-6">
                <p className="text-gray-600 mb-4 leading-relaxed">{partner.description}</p>
                
                <div className="space-y-2">
                  <h4 className="font-medium text-gray-900">Produits principaux :</h4>
                  {partner.products.map((product) => (
                    <div key={product} className="flex items-center space-x-2">
                      <i className="ri-check-line text-red-600 text-sm"></i>
                      <span className="text-sm text-gray-700">{product}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
